import { ConstraintFailureDetails } from './ConstraintFailureDetails';
import {
  ConstraintDiagnosticsStatus,
  ConstraintDiagnosticsStatusType,
  ConstraintDiagnosticsTarget,
  INFEASIBLE_RUN_STATUS
} from './constraint-diagnostics-constants';
import { useConstraintDiagnostics } from './use-constraint-diagnostics';

export const OptimizationFailureDetails = ({ target }: { target: ConstraintDiagnosticsTarget }) => {
  const diagnostics = useConstraintDiagnostics(target);
  if (target.status !== INFEASIBLE_RUN_STATUS) {
    return target.status.startsWith('FAIL') ? (
      <p className='mb-0'>Status: {target.status}</p>
    ) : null;
  }

  let detailsStatus: ConstraintDiagnosticsStatusType =
    diagnostics.data?.status ?? ConstraintDiagnosticsStatus.UNAVAILABLE;
  if (diagnostics.isLoading) {
    detailsStatus = ConstraintDiagnosticsStatus.LOADING;
  }
  if (diagnostics.isError) {
    detailsStatus = ConstraintDiagnosticsStatus.UNAVAILABLE;
  }

  return (
    <ConstraintFailureDetails
      status={detailsStatus}
      violationCount={diagnostics.data?.violationCount}
      violations={diagnostics.data?.violations}
    />
  );
};
